import { Component, OnInit, Input } from '@angular/core';
import { Validators, FormBuilder, FormArray, FormGroup, FormControl } from '@angular/forms';
import { FlashMessagesService } from 'angular2-flash-messages';
import { LimitFlowProposalService } from '../../service/limit-flow-proposal/limit-flow-proposal.service';

import { CommonService } from '../../../common/service/common.service';

@Component({
	selector: 'app-revenue',
	templateUrl: './revenue.component.html',
	styleUrls: ['./revenue.component.scss'],
	providers: [
		CommonService
	]
})
export class RevenueComponent implements OnInit {

	@Input('proposalID') proposalID: string = "";
	@Input('proposalStatus') proposalStatus: string = "";
	@Input('profileUser') profileUser: string = "";
	@Input('isProposalRevenue') isProposalRevenue: string = "";
	@Input('proposalRevenueDocument') proposalRevenueDocument: string = "";
	@Input('indice') indice: string = "";
	@Input('isUserOwner') isUserOwner: boolean = false;

	revenueRural: FormGroup;
	private token;
	public states: any[] = [];
	public citys: any[] = [];

	constructor(private fb: FormBuilder, private flashMessagesService: FlashMessagesService, private limitFlowProposalService: LimitFlowProposalService, private commonService: CommonService) {
		this.revenueRural = this.fb.group({
			Cultura: this.fb.array([]),
			CulturaID: '',
			EstadoID: '',
			Estado: '',
			CidadeID: '',
			Cidade: '',
			MesPlantio: '',
			MesColheita: '',
			ProdutividadeMedia: '',
			Preço: '',
			Arrendamento: '',
			Unidade: '',
			CustoHa: '',
			ConsumoFertilizante: '',
			PrecoMedioFertilizante: ''
		});
	}

	ngOnInit() {
		console.log("Load Revenue Tab");
		this.token = localStorage.getItem('yara.token');
		$("#tempPotencialReceitaIndiceGrupo").val(this.indice);
		this.getState();
	}

	getRentabilidadeTotalReceitaLiquidaPecuaria() {
		var retorno = Number($("#receitaLiquidaCriacaoAnimais").val()) * 100 / Number($("#receitaBrutaCriacaoAnimais").val());
		retorno = Number(retorno.toFixed(0));
		return retorno ? Number(retorno) : 0;
	}

	getTotalReceitaLiquidaPecuaria() {
		return Number($("#receitaLiquidaCriacaoAnimais").val());
	}

	getTotalReceitaLiquidaCultura() {
		return Number($("#receitaLiquidaCultura").val());
	}

	getTotalReceitaLiquidaOutras() {
		return Number($("#totalOutrasReceitas").val());
	}

	getRentabilidadeTotalReceitaLiquidaCultura() {
		var retorno = Number($("#receitaLiquidaCultura").val()) * 100 / Number($("#receitaBrutaCultura").val());
		retorno = Number(retorno.toFixed(0));
		return retorno ? Number(retorno) : 0;
	}

	getTotalReceitaPrevistas() {
		return Number(this.getTotalReceitaLiquidaPecuaria() + this.getTotalReceitaLiquidaCultura() + this.getTotalReceitaLiquidaOutras());
	}

	getTotalReceitaPrevistasRentabilidade() {

		// var receitaLiquidaCultura = Number($("#totalReceitaLiquidaCultura").val()).toFixed(0);
		// var receitaLiquidaCriacaoAnimais = Number($("#receitaLiquidaCriacaoAnimais").val()).toFixed(0);
		// var receitaBrutaCultura = Number($("#receitaBrutaCultura").val()).toFixed(0);
		// var receitaBrutaCriacaoAnimais = Number($("#receitaBrutaCriacaoAnimais").val()).toFixed(0);

		// var count = Number(Number(receitaLiquidaCultura) + Number(receitaLiquidaCriacaoAnimais) + Number(this.getTotalReceitaLiquidaOutras()) /
		// 	Number(receitaBrutaCultura) + Number(receitaBrutaCriacaoAnimais) + Number(this.getTotalReceitaLiquidaOutras()))

		// var valor = (Number(this.getTotalReceitaPrevistas()) * 100) / count;
		// valor = Number(valor.toFixed(0));
		// return valor ? Number(valor) : 0;

		if ((+$("#totalOutrasReceitas").val() + +$("#receitaBrutaCriacaoAnimais").val() + +$("#receitaBrutaTotal").val()) > 0) {
			return Math.round(+((this.getTotalReceitaPrevistas() / (+$("#totalOutrasReceitas").val() + +$("#receitaBrutaCriacaoAnimais").val() + +$("#receitaBrutaTotal").val())) * 100).toFixed(2));
		} else {
			return 0;
		}
	}

	initCulture() {
		return this.fb.group({
			Cultura: this.fb.array([]),
			CulturaID: '',
			EstadoID: '',
			Estado: '',
			CidadeID: '',
			Cidade: '',
			Area: '',
			MesPlantio: '',
			MesColheita: '',
			ProdutividadeMedia: '',
			Preço: '',
			Arrendamento: '',
			Unidade: '',
			CustoHa: '',
			ConsumoFertilizante: '',
			PrecoMedioFertilizante: ''
		});
	}

	addCulture() {
		const control = <FormArray>this.revenueRural.controls['Cultura'];
		const addrCtrl = this.initCulture();
		control.push(addrCtrl);
	}

	maxLengthCheck(e) {
		if (e.target.value.length > e.target.maxLength) {
			e.target.value = e.target.value.slice(0, e.target.maxLength)
		}
	}

	getState() {
		this.commonService.getState(this.token).subscribe(result => {
			if (result.Success) {
				this.states = result.Result;
			} else {
				this.flashMessagesService.show(result.Errors, { cssClass: 'alert-danger', timeout: 6000 });
			}
		}, error => {
			console.log(error);
		})
	}

	getRentabilidadeAgricola() {
		return this.getRentabilidadeTotalReceitaLiquidaCultura();
	}

	getRentabilidadeMediaTotal() {
		return this.getTotalReceitaPrevistasRentabilidade();
	}

	getDividaTotalReceitaBruta() {
		if (Number($("#receitaBrutaTotal").val()) > 0) {
			return ((Number($("#typeCpTotal").val()) + Number($("#typeLpTotal").val())) / Number($("#receitaBrutaTotal").val())).toFixed(2);
		} else {
			return 0;
		}
	}

	getDividaTotalEbtidaAgricola() {
		if (this.getTotalReceitaLiquidaCultura() > 0) {
			return +((Number($("#typeCpTotal").val()) + Number($("#typeLpTotal").val())) / this.getTotalReceitaLiquidaCultura()).toFixed(2);
		} else {
			return 0;
		}
	}

	getDividaTotalEbtida() {
		if (this.getTotalReceitaPrevistas() > 0) {
			return +((Number($("#typeCpTotal").val()) + Number($("#typeLpTotal").val())) / this.getTotalReceitaPrevistas()).toFixed(2);
		} else {
			return 0;
		}
	}

	getDividaTotalPatrimonio() {
		if ((+$("#totalArealTotalRural").val() + +$("#valorTotalComBenfeitoriasUrbano").val() + +$("#totalValorMaquinasEquipamentos").val()) > 0) {
			return Math.round(((+$("#typeCpTotal").val() + +$("#typeLpTotal").val()) / (+$("#totalArealTotalRural").val() + +$("#valorTotalComBenfeitoriasUrbano").val() + +$("#totalValorMaquinasEquipamentos").val())) * 100); //Number(this.limitFlowProposalService.proposalObj['PotencialPatrimonial']) * 100)).toFixed(2);
		} else {
			return 0;
		}
	}

}


// WEBPACK FOOTER //
// ./src/app/limit-flow-proposal/component/revenue/revenue.component.ts